import NavAccordion from './NavAccordion';

export default NavAccordion;
